import React from 'react';

export const ReviewCard = ({ review }) => {
  return (
    <div className="review-card">
      <div className="review-quote">{review.quote}</div>
      <div className="review-author">
        <div className="review-name">{review.name}</div>
        <div className="review-title">{review.title}</div>
        <div className="review-stars">★★★★★</div>
      </div>
    </div>
  );
};